import React, { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'react-feather';
import './SocialWall.css';

const ImageLightbox = ({ images, currentIndex, onClose, onNext, onPrev }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      } else if (e.key === 'ArrowLeft') {
        onPrev();
      } else if (e.key === 'ArrowRight') {
        onNext();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, onNext, onPrev]);

  if (!images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <div className="image-lightbox-overlay" onClick={onClose}>
      <div className="image-lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        {images.length > 1 && (
          <>
            <button className="lightbox-nav lightbox-prev" onClick={onPrev}>
              <ChevronLeft size={32} />
            </button>
            <button className="lightbox-nav lightbox-next" onClick={onNext}>
              <ChevronRight size={32} />
            </button>
          </>
        )}

        <div className="lightbox-image-container">
          <img src={currentImage.url} alt={`Image ${currentIndex + 1}`} />
        </div>

        {images.length > 1 && (
          <div className="lightbox-counter">
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageLightbox;

